import React, { useCallback, useState } from 'react'
import { Box, Grid, Accordion, AccordionSummary, AccordionDetails, Theme, Button, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as ls from 'local-storage'
import { ModerTwoAccessStageModal } from '../modals/two-access-stage'
import { propsAction } from '../../../store/props'
import { showCheckList } from '../../../api'
import { modalsAction } from '../../../store/modals'
import { N1Approves } from '../../../types/default-types'

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

export const TwoAccessStage: React.FC<{
  img: any
  data: any
  className: any
  expanded: boolean
  updateInfo(): void
  onExpand: () => void
  openCheckList: () => void
}> = ({
  data = [],
  updateInfo,
  className,
  img = [],
  openCheckList = () => {},
  expanded,
  onExpand = () => {},
}): JSX.Element => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const mdDown = useMediaQuery(({ breakpoints: { down } }: Theme) => down(960))
  const smDown = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const [moderTwoAccessStageModal, setModerTwoAccessStageModal] = useState<boolean>(false)
  const [confirm, setConfirm] = useState<any>({
    request: undefined,
    type: true,
  })
  const [disabledBtn, setDisabledBtn] = useState<boolean>(false)

  const loadCheckLists = useCallback((index: number, status: string) => {
    setDisabledBtn(true)
    openCheckList()
    let checklist_all = {
      loaded: true,
      employee: undefined,
      checklist: undefined,
    }

    dispatch(propsAction.setProps({ checklist_all }))

    showCheckList({ checklistId: data[index].checklists[0].id })
      .then((res) => {
        if (res.status === 1) {
          checklist_all = {
            loaded: false,
            employee: { ...data[index], checklist: { ...data[index].checklists[0] }, stage: 1 },
            checklist: { ...res.data.checklist },
          }
          dispatch(propsAction.setProps({ checklist_all }))
          ls.set('checklist', '?checklist')
          setDisabledBtn(false)
        } else {
          dispatch(
            modalsAction.alert({
              message: { error: [`${res.message}`] },
              onClose: () => {
                setDisabledBtn(false)
                navigate('../lk')
              },
            })
          )
        }
      })
      .catch(() => {
        dispatch(
          modalsAction.alert({
            message: { error: ['Сервер временно недоступен. Пожалуйста, попробуйте позже'] },
            onClose: () => {
              setDisabledBtn(false)
              navigate('../lk')
            },
          })
        )
      })
  }, [])

  return (
    <>
      <ModerTwoAccessStageModal
        confirm={confirm.type}
        updateInfo={updateInfo}
        requestId={confirm.request}
        show={moderTwoAccessStageModal}
        onClose={() => setModerTwoAccessStageModal(false)}
      />

      <Box className={classes.accessStage}>
        <Accordion id="accessStage" expanded={expanded} onChange={onExpand} square={false}>
          <AccordionSummary expandIcon={<Icon className={className} img={img} />}>
            Приём во второй этап
          </AccordionSummary>
          <AccordionDetails>
            <Box className={className.contentAccordionDetails}>
              {data.map((item: N1Approves, index: number) => {
                return (
                  <Box key={`accessStage${index}`} className={classes.accessStageItem} pb={1}>
                    <Grid
                      container
                      wrap={smDown ? 'wrap' : 'nowrap'}
                      justifyContent="space-between"
                      alignItems="flex-start"
                      spacing={2}
                    >
                      <Grid item xs={6}>
                        <Box className={classes.accessStageName}>
                          {item.command.users.length > 1 ? (
                            item.command.users.length > 1 && `Команда «${item.command.name}»`
                          ) : (
                            <>
                              {item.command.users[0].lastName} {item.command.users[0].firstName}{' '}
                              {item.command.users[0].middleName}
                            </>
                          )}
                        </Box>
                        <Box className={classes.accessStageNomination}>«{item.nomination.name}»</Box>

                        {!smDown && item.finalStatus !== 'NEW' && (
                          <Box className={classes.accessStageStatus}>Статус:&nbsp;{item.finalStatusName}</Box>
                        )}

                        {!smDown && item.finalStatus === 'NEW' && item.finalBtnShow && (
                          <Box className={classes.accessStageConfirm}>
                            <Grid
                              container
                              wrap="nowrap"
                              justifyContent={smDown ? 'center' : 'flex-start'}
                              spacing={mdDown ? 1 : 2}
                            >
                              <Grid item>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  className={classes.btn}
                                  onClick={() => {
                                    setConfirm({
                                      request: item.id,
                                      type: true,
                                    })
                                    setModerTwoAccessStageModal(true)
                                  }}
                                >
                                  Принять
                                </Button>
                              </Grid>
                              <Grid item>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  className={classes.btnReject}
                                  onClick={() => {
                                    setConfirm({
                                      request: item.id,
                                      type: false,
                                    })
                                    setModerTwoAccessStageModal(true)
                                  }}
                                >
                                  Отклонить
                                </Button>
                              </Grid>
                            </Grid>
                          </Box>
                        )}
                      </Grid>

                      {smDown && (
                        <Grid item xs="auto">
                          <Box
                            className={classes.linkCheckList}
                            onClick={() => loadCheckLists(index, item.finalStatus)}
                          >
                            Чек-лист
                          </Box>
                        </Grid>
                      )}

                      <Grid item xs={12} sm={3} md={2}>
                        <Grid
                          container
                          direction={smDown ? 'row' : 'column'}
                          justifyContent="flex-start"
                          alignItems={smDown ? 'center' : 'flex-start'}
                          spacing={1}
                        >
                          <Grid item xs={5} sm="auto">
                            <Grid container wrap="nowrap" alignItems="center" spacing={1}>
                              <Grid item xs="auto">
                                <Box className={classes.crit}>Баллы:</Box>
                              </Grid>
                              <Grid item xs="auto">
                                <Box className={classes.crit}>
                                  {item.checklists && item.checklists[0].percent}&nbsp;%
                                </Box>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={3} sm="auto">
                            <Grid container wrap="nowrap" alignItems="center" spacing={smDown ? 1 : 2}>
                              <Grid item xs="auto">
                                <img src={img.attentionL1} alt="" width={20} height={20} />
                              </Grid>
                              <Grid item xs="auto">
                                <Box className={classes.crit}>{item.checklists && item.checklists[0].l1}</Box>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={3} sm="auto">
                            <Grid container wrap="nowrap" alignItems="center" spacing={smDown ? 1 : 2}>
                              <Grid item xs="auto">
                                <img src={img.attentionL2} alt="" width={20} height={20} />
                              </Grid>
                              <Grid item xs="auto">
                                <Box className={classes.crit}>{item.checklists && item.checklists[0].l2}</Box>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                      {!smDown && (
                        <Grid item xs="auto">
                          <Box
                            className={classes.linkCheckList}
                            onClick={() => loadCheckLists(index, item.finalStatus)}
                          >
                            Чек-лист
                          </Box>
                        </Grid>
                      )}
                    </Grid>
                    {smDown && (
                      <Grid container justifyContent="flex-start" alignItems="center">
                        <Grid item xs={12}>
                          {item.finalStatus !== 'NEW' && (
                            <Box className={classes.accessStageStatus}>{item.finalStatusName}</Box>
                          )}

                          {item.finalStatus === 'NEW' && item.finalBtnShow && (
                            <Box className={classes.accessStageConfirm}>
                              <Grid container justifyContent="center">
                                <Grid item>
                                  <Grid container wrap="nowrap" spacing={mdDown ? 1 : 2}>
                                    <Grid item>
                                      <Button
                                        variant="contained"
                                        color="secondary"
                                        className={classes.btn}
                                        onClick={() => {
                                          setConfirm({
                                            request: item.id,
                                            type: true,
                                          })
                                          setModerTwoAccessStageModal(true)
                                        }}
                                      >
                                        Принять
                                      </Button>
                                    </Grid>
                                    <Grid item>
                                      <Button
                                        variant="contained"
                                        color="secondary"
                                        className={classes.btnReject}
                                        onClick={() => {
                                          setConfirm({
                                            request: item.id,
                                            type: false,
                                          })
                                          setModerTwoAccessStageModal(true)
                                        }}
                                      >
                                        Отклонить
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Box>
                          )}
                        </Grid>
                      </Grid>
                    )}
                  </Box>
                )
              })}
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  )
}

const useStyles = makeStyles(({ spacing, font, breakpoints: { down }, palette }: Theme) => ({
  accessStage: {},
  accessStageItem: {
    marginBottom: 10,
  },
  accessStageName: {
    fontSize: 16,
    paddingRight: 15,
    fontWeight: 500,
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  accessStageNomination: {
    fontSize: 16,
    paddingTop: 7,
    fontWeight: 500,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
      marginBottom: -15,
    },
  },
  accessStageStatus: {
    fontSize: 16,
    fontWeight: 500,
    color: '#6C6C6C',
    paddingTop: 5,
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  accessStageConfirm: {
    marginTop: 15,
    marginBottom: 15,
    [down('md')]: {
      marginTop: 10,
      marginBottom: 10,
    },
  },
  crit: {
    fontSize: 16,
    fontWeight: 500,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  linkCheckList: {
    fontSize: 17,
    fontWeight: 600,
    color: '#6C6C6C',
    textDecoration: 'underline',
    cursor: 'pointer',
    transition: '0.3s',
    textDecorationColor: '#6C6C6C!important',
    '-webkit-tap-highlight-color': 'transparent',
    '&:hover': {
      textDecorationColor: 'rgba(255, 255, 255, 0.5)!important',
      color: 'rgba(255, 255, 255, 0.5)!important',
    },
    [down('md')]: {
      fontSize: 16,
    },
    [down('sm')]: {
      fontSize: 15,
    },
  },
  btn: {
    fontSize: '16px!important',
    padding: '10px 30px!important',
    minHeight: '35px!important',
    [down('md')]: {
      fontSize: '14px!important',
      padding: '10px 17px!important',
      minHeight: '30px!important',
      minWidth: '120px!important',
    },
    [down('sm')]: {
      fontSize: '12px!important',
      padding: '10px 17px!important',
      minHeight: '25px!important',
      minWidth: '145px!important',
    },
  },
  btnReject: {
    fontSize: '16px!important',
    padding: '10px 30px!important',
    minHeight: '35px!important',
    color: `${palette.primary.dark}!important`,
    backgroundColor: '#6C6C6C!important',
    '&:hover': {
      color: `${palette.text.primary}!important`,
      backgroundColor: `#5b5b5b!important`,
    },
    [down('md')]: {
      fontSize: '14px!important',
      padding: '10px 17px!important',
      minHeight: '30px!important',
      minWidth: '120px!important',
    },
    [down('sm')]: {
      fontSize: '12px!important',
      padding: '10px 17px!important',
      minHeight: '25px!important',
      minWidth: '145px!important',
    },
  },
}))
